import styled, { css } from 'styled-components';

import { wellzTheme } from '@wellz-theme/mui';

import { MenuWidth, MenuWidthCollapsed } from 'components/Menu/styles';

import { ContainerProps } from './types';

export const Container = styled.div<ContainerProps>`
  ${({ showMenu }) => css`
    ${showMenu &&
    css`
      margin-left: 0;
      padding-top: ${wellzTheme.spacing(8)};

      @media screen and (min-width: 1024px) {
        margin-left: ${MenuWidthCollapsed};
        padding-top: 0;
      }

      @media screen and (min-width: 1440px) {
        margin-left: ${MenuWidth};
        padding-top: 0;
      }
    `}
  `}
`;
